import { useMemo, memo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'UIComponents/elements/headings';
import UISection from 'UIComponents/section/UISection';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { useFetchProductDetails } from './hooks/useFetchProductDetails';
import { jsx as _jsx } from "react/jsx-runtime";
function ProductHighlightHeader({
  objectId
}) {
  const {
    data,
    loading,
    error
  } = useFetchProductDetails(objectId);
  const productName = useMemo(() => {
    const productNameProperty = data && data.crmObject.properties.find(property => property.name === 'name');
    return productNameProperty && productNameProperty.value || '';
  }, [data]);
  if (loading) {
    return /*#__PURE__*/_jsx(UILoadingDots, {
      "data-test-id": "product-highlight-card-content-loading"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx("div", {
      className: "p-top-12 m-x-auto",
      children: /*#__PURE__*/_jsx(UIErrorMessage, {
        "data-test-id": "product-highlight-card-content-error",
        type: "error",
        title: I18n.text('error.title'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "error.errorMessage"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(UISection, {
    "data-selenium-test": "universal-sidebar-highlight",
    children: /*#__PURE__*/_jsx(H2, {
      className: "text-left p-left-6",
      children: productName
    })
  });
}
export default /*#__PURE__*/memo(ProductHighlightHeader);